export class SideTitle {
  position = 'uk-position-top-left';
  rotation = 'uk-element-rotate';
  breakpoint = 'uk-visible';
  color = 'uk-visible';
}
